import './Login.css';
import TMALogo from "../../assets/toyota-asia-logo.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchRequest } from '../../utils/Fetcher';
import { setSession } from "../../store/sessionSlice";
import { auth, provider } from "../../utils/firebase";
import { signInWithPopup } from "firebase/auth";
import { message } from "antd";
import { useState } from "react";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);

  const bootstrapSession = async ({ userId, accessToken, userName }) => {
    const { result } = await fetchRequest({
      method: "POST",
      path: "auth/login",
      data: JSON.stringify({ userId, accessToken }),
    });

    const loginData = result?.data;

    if (loginData?.sessionId) {
      dispatch(
        setSession({
          sessionToken: loginData.sessionToken,
          sessionId: loginData.sessionId,
          userId: loginData.userId ?? userId,
          identityToken: accessToken,
          userName: loginData?.userName ?? userName,
        })
      );
      return;
    }

    const { result: created } = await fetchRequest({
      method: "POST",
      path: "auth/sessions/create",
      data: JSON.stringify({ userId }),
    });

    dispatch(
      setSession({
        sessionToken: created.sessionToken,
        sessionId: created.sessionId,
        userId: created.userId ?? userId,
        identityToken: accessToken,
        userName: userName,
      })
    );
  };

  const getLoginErrorMessage = (error) => {
    const apiMessage =
      error?.response?.data?.message ||
      error?.result?.message ||
      error?.message;

    const errorCode = error?.code;

    if (errorCode === "auth/popup-closed-by-user") {
      return "Login was cancelled because the sign-in window was closed.";
    }

    if (errorCode === "auth/cancelled-popup-request") {
      return "A previous sign-in attempt is still in progress. Please try again.";
    }

    if (errorCode === "auth/popup-blocked") {
      return "The sign-in popup was blocked by your browser. Please allow popups and try again.";
    }

    if (
      apiMessage?.toLowerCase().includes("unauthorized") ||
      apiMessage?.toLowerCase().includes("forbidden") ||
      apiMessage?.toLowerCase().includes("not allowed") ||
      apiMessage?.toLowerCase().includes("whitelist")
    ) {
      return "Your account is not authorized to access this application. Please contact your administrator.";
    }

    return apiMessage || "Login failed. Please try again.";
  };

  const testCall = async () => {
    try {
      setLoading(true);

      const userId = process.env.REACT_APP_TEST_USER_ID;
      const accessToken = process.env.REACT_APP_TEST_USER_TOKEN;

      await bootstrapSession({ userId, accessToken, userName: "Test User" });
      navigate("/home");
    } catch (e) {
      console.error(e);
      messageApi.error(getLoginErrorMessage(e));
    } finally {
      setLoading(false);
    }
  };

  const handleMicrosoftLogin = async () => {
    try {
      setLoading(true);

      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const accessToken = await user.getIdToken(false);

      // nanti kalau udah rapih bisa ganti ke email
      await bootstrapSession({ userId: user.uid, accessToken, userName: user.displayName });
      messageApi.success("Login berhasil.");
      navigate("/home");
    } catch (e) {
      console.error("Microsoft Login Error:", e);
      messageApi.error(getLoginErrorMessage(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {contextHolder}

      <div className="login-container">
        <div>
          <img src={TMALogo} className="login-logo" alt="Toyota Asia Logo" />
          <div className="login-title">Creative Zenith</div>

          <button
            className="login-button"
            onClick={handleMicrosoftLogin}
            disabled={loading}
          >
            {loading ? "Signing in..." : "Log in using SSO"}
          </button>

          {/* <button
            className="login-button"
            onClick={testCall}
            disabled={loading}
          >
            {loading ? "Signing in..." : "Log in using SSO (test)"}
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default Login;